export const CREATE_NEW_PURCHASE = "CREATE_NEW_PURCHASE";
export const PURCHASE_PRODUCT_MODAL = "PurchaseProductModal";
export const PURCHASE_IS_LOADING = "PURCHASE_IS_LOADING";
export const RESET_PURCHASE_MESSAGE = "RESET_PURCHASE_MESSAGE";
